// Connects to data-controller="clipper-number-length"

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "clipperNumber", "errors"]

  checkLength() {
    const value = this.inputTarget.value.trim()

    if (value.length > 18) {
      this.submitTarget.disabled = true
      this.clipperNumberTarget.classList.add("red")
      this.errorsTarget.innerHTML = I18n.t('modern.transit_card.linking.card.clipper.error.nineteen_characters_html')
    } else  {
      this.submitTarget.disabled = false
      this.clipperNumberTarget.classList.remove("red")
      this.errorsTarget.innerHTML = "";
    }
  }
}